import { useConst } from '@execonline-inc/react-hooks.private';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { NotificationsContext } from '../../Notifications';
import NotificationsStore from '../../Notifications/Store';
import PlatformWrapperContext, { PlatformWrapperRef } from '../PlatformWrapperContext';
import PlatformBody from './PlatformBody';

function Platform() {
  const notifications = useConst(() => new NotificationsStore());
  const platformWrapper: PlatformWrapperRef = useRef<HTMLDivElement>(null);

  return (
    <PlatformWrapperContext.Provider value={just(platformWrapper)}>
      <div className="min-h-screen bg-[#FAFAFA] flex flex-col" ref={platformWrapper}>
        <NotificationsContext.Provider value={notifications}>
          <PlatformBody />
        </NotificationsContext.Provider>
      </div>
    </PlatformWrapperContext.Provider>
  );
}

export default observer(Platform);
